import current from "./coderconfig.js";
// import J from "../common.js";
const api = {
	apiBase: current.GetApiBaseUrl(),
	imgBase: current.GetImgBaseUrl(), 
	Main: { //主框架  公用
		getDic: "/sso/dict/get/by/code.ajax", //获取数据字典
		getInfo: "/sso/get/login/info.ajax" //根据token 获取用户信息
	},
	LoginApi: {
		simulateLogin: '/sso/simulate/login.ajax' //根据员工id 获取 token
	},
	CommonApi: {
		//下载
		download: "/sso/attachment/download.ajax",
		//上传
		upload: "/sso/attachment/save/multipart/file.ajax",
		//短信数
		smsCount: "/notify/data/sms/surplus/count.ajax",
		//组织结构和人员
		tree: "/sso/department/list/department/employee/tree.ajax",
		//组织结构树列表
		departmentTree: '/sso/department/list/department/tree.ajax',
		//组织结构信息查询
		departmentSearchTree: "/sso/department/list/department/search/tree.ajax",
		//组织结构员工信息查询
		employeeSearchTree: "/sso/employee/list/employee/search/tree.ajax",

		//根据ID获取附件列表
		getFileByIds: "/sso/attachment/get/ids.ajax",
		//发送手机号
		smsCode: "/notify/record/send/sms/code.ajax"
	},
	APP: {
		list: "/notify/apply/list.ajax", //首页菜单
		remove: "/notify/apply/remove.ajax", //删除一个应用 id
		modify: "/notify/apply/modify.ajax", //修改  id 不能为空  name icon 必须更改一项
		get: "/notify/apply/get.ajax", //获取单个应用详情 id
		save: "/notify/apply/save.ajax" //添加
	},
	PublicNotice: {
		//通知数据保存  第一步
		save: "/notify/data/save.ajax",
		//导入excel文件  第二部
		excel: "/notify/data/detail/import/excel.ajax",
		//导入直接发送 第三部
		send: "/notify/data/send.ajax",
		//查看通知数据详情
		get: "/notify/data/get.ajax",
		//列表
		list: "/notify/data/common/list/data.ajax",
		//搜索
		search: "/notify/data/common/search.ajax",
		//表头
		head: "/notify/data/common/list.ajax",
		//下载模板
		template: "/notify/data/template.ajax"

	},
	PublicNoticeDetailList: {
		//列表
		list: "/notify/data/common/detail/list/data.ajax",
		//搜索
		search: "/notify/data/common/detail/search.ajax",
		//表头
		head: "/notify/data/common/detail/list.ajax",
		//撤回通知-批量
		batchRevocation: "/notify/data/detail/revocation/batch.ajax",
		//撤回通知
		revocation: "/notify/data/detail/revocation.ajax", 
		//单条数据详情
		get: "/notify/data/detail/get.ajax",
		//重发-表头
		resendHead: '/notify/data/detail/common/resend/list.ajax',
		//重发-数据
		resendList: '/notify/data/detail/common/resend/list/data.ajax',
		//重发-批量
		batchResend: "/notify/data/detail/common/resend/batch.ajax",
		//重发
		resend: ""
	},
	OtherNotice: { 
		SEND_SMS: {
			//列表
			list: "/notify/data/sms/list/data.ajax",
			//搜索
			search: "/notify/data/sms/search.ajax",
			//表头
			head: "/notify/data/sms/list.ajax",
			// /通知数据保存-短信
			save: "/notify/data/sms/save.ajax",
			//重发-表头
			resendHead: '/notify/data/detail/sms/resend/list.ajax',
			//重发-数据
			resendList: '/notify/data/detail/sms/resend/list/data.ajax',
			//重发-批量
			batchResend: "/notify/data/detail/sms/resend/batch.ajax",

			//详情列表
			detailList: "/notify/data/sms/detail/list/data.ajax",
			//详情搜索
			detailSearch: "/notify/data/sms/detail/search.ajax",
			//详情表头
			detailHead: "/notify/data/sms/detail/list.ajax",
		},
		SEND_MAIL: {
			//列表
			list: "/notify/data/mail/list/data.ajax",
			//搜索
			search: "/notify/data/mail/search.ajax",
			//表头
			head: "/notify/data/mail/list.ajax",
			// /通知数据保存 
			save: "/notify/data/mail/save.ajax",
			//重发-表头
			resendHead: '/notify/data/detail/mail/resend/list.ajax', 
			//重发-数据
			resendList: '/notify/data/detail/mail/resend/list/data.ajax',
			//重发-批量
			batchResend: "/notify/data/detail/mail/resend/batch.ajax",
			//详情列表
			detailList: "/notify/data/mail/detail/list/data.ajax",
			//详情搜索
			detailSearch: "/notify/data/mail/detail/search.ajax",
			//详情表头
			detailHead: "/notify/data/mail/detail/list.ajax",
		},
		SEND_PUSH: {
			//列表
			list: "/notify/data/push/list/data.ajax",
			//搜索
			search: "/notify/data/push/search.ajax",
			//表头
			head: "/notify/data/push/list.ajax",
			//通知数据保存 
			save: "/notify/data/push/save.ajax",
			//重发-表头
			resendHead: '/notify/data/detail/push/resend/list.ajax',
			//重发-数据
			resendList: '/notify/data/detail/push/resend/list/data.ajax',
			//重发-批量
			batchResend: "/notify/data/detail/push/resend/batch.ajax",
			//详情列表
			detailList: "/notify/data/push/detail/list/data.ajax",
			//详情搜索
			detailSearch: "/notify/data/push/detail/search.ajax",
			//详情表头
			detailHead: "/notify/data/push/detail/list.ajax",
		}
	},
	//通讯录
	EnterpriseWeChat: {
		//同步通讯录
		synchronize: "" ,
		//列表
		list: "/sso/employee/list/data.ajax",
		//搜索
		search: "/sso/employee/search.ajax",
		//表头
		head: "/sso/employee/list.ajax",
		//下载更新模板
		downloadUpdateTmp: '/sso/employee/download/update/template.ajax',
		//上传更新
		uploadUpdate: '/sso/employee/upload.ajax',
		//获取员工详情
		get: "/sso/employee/get.ajax",
		//修改员工信息
		modify: "/sso/employee/modify.ajax"
		
	},
	//管理员
	Admin: {
		//列表
		list: "/sso/data/auth/list/data.ajax",
		//搜索
		search: "/sso/data/auth/search.ajax",
		//表头
		head: "/sso/data/auth/list.ajax",
		//获取未选择员工列表
		employee: "/sso/employee/list/employee/admin.ajax",
		//删除
		remove: "/sso/data/auth/remove.ajax",
		//保存
		save: "/sso/data/auth/save.ajax",
		//修改
		modify: "/sso/data/auth/modify.ajax",
		//获取单个
		get: "/sso/data/auth/get.ajax"
	},
	PersonalCenter: {
		//订单
		Order: {
			//列表
			list: "/notify/pay/order/list/data.ajax",
			//搜索
			search: "/notify/pay/order/search.ajax",
			//表头
			head: "/notify/pay/order/list.ajax",
			//保存订单
			save: "/notify/pay/order/save.ajax",
			//取消订单
			cancel: "/notify/pay/order/cancel.ajax",
			//支付
			pay: "/notify/pay/order/pay.ajax"
		},
		//短信发送
		SendSMSLog: {
			//列表
			list: "/notify/record/list/data.ajax",
			//搜索
			search: "/notify/record/search.ajax",
			//表头
			head: "/notify/record/list.ajax",
		},
		//发票
		Invoice: {
			//可开发票列表
			orders: "/notify/pay/invoice/orders.ajax",
			//保存
			save: "/notify/pay/invoice/save.ajax",
			//开票历史
			history: "/notify/pay/invoice/list/data.ajax",
			//开票历史当个详情
			historyDetail: "/notify/pay/invoice/order/detail.ajax"
		},
		//个人中心系统信息
		index: "/notify/customer/config/get/config.ajax",
		//商品列表
		ProductList: "/notify/pay/product/list/data.ajax",

	},
	NoticeDeatil: {
		//查看通知详情
		getDetailNotce: '/notify/data/detail/info/get.ajax',
		//查看是否需要密码   该人是否设置密码
		checkPwd: "/notify/msg/check/pwd.ajax",
		//确认
		confirm: "/notify/data/detail/info/confirm.ajax",
		//反馈
		feedback:"/notify/data/detail/info/feedback.ajax",
		//确认员工读取密码
		readPassword: "/sso/employee/get/confirm/read/password.ajax",
		//重置员工读取密码
		resetPassword: "/sso/employee/update/read/password.ajax",
		//H5消息首页
		index: "/notify/msg/index/data.ajax",
		//H5获取应用消息列表
		list: "/notify/msg/list/data.ajax"
	}
}

export default api;